module.exports = __webpack_public_path__ + "img/22.99fbb8c9.jpg";